export default {
    debug: true,
}